<template>
  <v-container :class="[$vuetify.breakpoint.xsOnly ? 'ma-0 pa-0' : '']">
    <WorkRequestCardPage v-if="workRequest" :workRequest="workRequest" />
    <!-- <OperationPlanTable
      v-if="workRequest && (workRequest.StageCode =='P' || workRequest.StageCode =='E')"
      :workRequestId="workRequestId"
    />-->
  </v-container>
</template>


<script>
import WorkRequestCardPage from '../components/WorkRequestCardPage';
// import OperationPlanTable from "../components/OperationPlanTable";

import { mapActions } from 'vuex';

export default {
  name: 'workRequest',
  components: {
    WorkRequestCardPage,
    // OperationPlanTable
  },
  methods: {
    ...mapActions(['updateWorkRequests'])
  },
  mounted() {
    if (this.workRequestId) {
      this.updateWorkRequests({ workRequestId: this.workRequestId })
    }
  },
  computed: {
    workRequest() {
      return this.$store.state.workRequests.workRequests.find(e => {
        return this.workRequestId === e.IdApplication
      })
    },
    workRequestId() {
      return parseInt(this.$route.params.idapplication)
    },
    currentLocale() {
      return this.$store.getters.currentLocale
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    }
  },
  watch: {
    isAuthenticated() {
      if (this.workRequestId) {
        this.updateWorkRequests({ workRequestId: this.workRequestId })
      }
    },
    currentLocale() {
      if (this.workRequestId) {
        this.updateWorkRequests({ workRequestId: this.workRequestId })
      }
    }
  }
}
</script>